import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import negativeImg from '../images/NEGATIVE-2.svg';
import negatifImg from '../images/NEGATIF.svg';
import positiveImg from '../images/POSITIVE.svg';
import positifImg from '../images/POSITIF.svg';
import equivocalImg from '../images/EQUIVOCAL-1.svg';
import equivoqueImg from '../images/EQUIVOQUE.svg';
import noresult from '../images/Result-Not-Available.svg';
import cancelledImg from '../images/Result-Cancelled.svg';
import annuleImg from '../images/Resultat-annule.svg';
import invalidImg from '../images/Invalid-Result.svg';
import invalideImg from '../images/Resultat-pas-valides.svg';
import aucunresult from '../images/Resultat-non-disponible.svg';
import * as moment from 'moment';
import DownloadPDFButton from "./downloadPDFButton";

import { formatDate } from '../util/util';

import { POSITIVE, NEGATIVE, PENDING, EQUIVOCAL, UNKNOWN, NORESULT, CANCELLED, INVALID } from '../api/mappers/labResultMapper';

import { LANG_EN, LANG_FR } from '../util/language_v3';

const RecentResult = (props) => {
    const { deviceType } = props;
    const classes = useStyles();
    //<span class="badge badge-green badge-pill">{formatResult(props.result, props.strings)}</span>
    return (
        <div className="row">
            <div className="col-12 col-md-4">
                <div class="circle"><img src={getImage(props.result, props.language)} width="60%" /></div>
            </div>
            <div className="col-12 col-md-8 ml-auto">
                <div className="section">
                    <ul class="list-group">
                        {renderTestDate(props.result, props.collectionDate, props.language, props.strings)}
                        <LabelledItem result={props.result} label={props.strings.RECENT_RESULTS_RESULT_DATE} content={formatDate(props.resultDate, props.language)} />
                        <LabelledItem result={props.result} label={props.strings.RESULTS_TAG} content={formatResult(props.result, props.strings)} />
                        <LabelledItem result={props.result} label={props.strings.RECENT_RESULTS_LOCATION} content={props.collectionSite} />
                        {[POSITIVE, NEGATIVE].includes(props.result) ?
                            <>
                                <LabelledItem result={props.result} label={props.strings.RECENT_RESULTS_LAB_ADDRESS} content={props.labAddress} />
                                <InfoItem result={props.result} string={props.strings.RECENT_RESULTS_TEST_TYPE} />
                            </>
                            : null}
                        <DownloadPDFButton isHidden={!['Mobile', 'Tablet'].includes(deviceType)} />
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default RecentResult;

function renderTestDate(result, collectionDate, language, strings) {
    if (result === NORESULT) {
        return null;
    }
    let d = moment(collectionDate, moment.ISO_8601);
    if (collectionDate === null || collectionDate === undefined || !d.isValid()) {
        return (
            <li class="list-group-item d-flex justify-content-between align-items-center">
                {strings.RECENT_RESULTS_TEST_DATE}
                <span class="badge">{strings.NO_COLLECTION_DATE}</span>
            </li>
        )
    } else {
        return (
            <li class="list-group-item d-flex justify-content-between align-items-center">
                {strings.RECENT_RESULTS_TEST_DATE}
                <span class="badge">{formatDate(collectionDate, language)}</span>
            </li>
        )
    }
}

const LabelledItem = (props) => {
    const { result, label, content } = props;
    if (result === NORESULT) {
        return null;
    }
    if (Array.isArray(content)) {
        return (
            <li class="list-group-item d-flex justify-content-between align-items-center">
                {label}
                <span class="badge badge-green badge-pill">
                    <p class="text-left mb-0">
                        {content.map(item => <b>{item}<br /></b>)}
                    </p>
                </span>
            </li>
        );
    }
    return (
        <li class="list-group-item d-flex justify-content-between align-items-center">
            {label}
            <span class="badge badge-green badge-pill wrap-content"><b>{content}</b></span>
        </li>
    )
}

const InfoItem = (props) => {
    const { result, string } = props;
    if (result == NORESULT) {
        return null;
    }
    return (
        <li class="list-group-item d-flex justify-content-between align-items-center">
            <b>{string}</b>
        </li>
    )
}

function formatResult(result, strings) {
    if (result === POSITIVE) {
        return strings.TEST_POSITIVE;
    } else if (result === NEGATIVE) {
        return strings.TEST_NEGATIVE;
    } else if (result === EQUIVOCAL) {
        return strings.TEST_EQUIVOCAL;
    } else if (result === PENDING) {
        return strings.TEST_PENDING;
    } else if (result === CANCELLED) {
        return strings.TEST_CANCELLED;
    } else if (result === INVALID) {
        return strings.TEST_INVALID;
    } else {
        return strings.TEST_NORESULT;
    }
}

// FIXME Requires pending/unknown image.
function getImage(result, lang) {
    let img = noresult;
    if (lang === LANG_FR) {
        img = aucunresult;
    }
    if (result === POSITIVE) {
        if (lang === LANG_EN) {
            img = positiveImg;
        } else {
            img = positifImg;
        }
    } else if (result === NEGATIVE) {
        if (lang === LANG_EN) {
            img = negativeImg;
        } else {
            img = negatifImg;
        }
    } else if (result === EQUIVOCAL) {
        if (lang === LANG_EN) {
            img = equivocalImg;
        } else {
            img = equivoqueImg;
        }
    } else if (result === CANCELLED) {
        if (lang === LANG_EN) {
            img = cancelledImg;
        } else {
            img = annuleImg;
        }
    }
    else if (result === INVALID) {
        if (lang === LANG_EN) {
            img = invalidImg;
        } else {
            img = invalideImg;
        }
    }
    return img;
}

const useStyles = makeStyles(theme => ({
    icon: {
        fontSize: 30
    },
    info: {
        display: "flex",
        flexGrow: 1,
        width: 326,
        alignContent: "center"
    },
    resultsImg: {
        width: 200,
        height: 200,
        paddingRight: 15
    },
    row: {
        verticalAlign: 'middle',
        display: 'inline-block',
    }
}));
